import VehicleVersion from './VehicleVersion'

export default VehicleVersion
